import { Sparkles, Github, LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';

import { apiClient } from '../lib/api.js';
import { useAuth } from '../lib/auth-context.js';
import { cn } from '../lib/utils.js';

export function Header(): JSX.Element {
  const { user, logout, loading } = useAuth();

  return (
    <header className="border-b sticky top-0 bg-background z-10">
      <div className="container flex items-center justify-between h-14">
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <Sparkles className="h-5 w-5" />
          <span>arx marketplace</span>
        </Link>
        <nav className="flex items-center gap-3 text-sm">
          {loading ? null : user ? (
            <>
              <Link
                to="/publish"
                className="px-3 py-1.5 rounded-md hover:bg-secondary transition-colors"
              >
                Publish
              </Link>
              <span className="text-muted-foreground hidden sm:inline">{user.name}</span>
              <button
                onClick={() => void logout()}
                className={cn(
                  'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border',
                  'hover:bg-secondary transition-colors',
                )}
              >
                <LogOut className="h-4 w-4" />
                <span className="sr-only sm:not-sr-only">Sign out</span>
              </button>
            </>
          ) : (
            <a
              href={apiClient.loginGithubUrl()}
              className={cn(
                'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border',
                'hover:bg-secondary transition-colors',
              )}
            >
              <Github className="h-4 w-4" />
              Sign in
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}
